import React from "react";
import { getMarchi, getMarchiForDropdown, getModelliForDropdown, } from './remoteHandler'

import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
} from "react-router-dom";

import ParticlesBg from 'particles-bg'

//SELECT
import Select from 'react-select';

//Style
import './Home.css'
import Direct from "./Direct";


class Home extends React.Component {

    state = {
        marcaSelected: getMarchi()[0],
        telecomandoSelected: "",
        marchi: getMarchiForDropdown(),
        telecomandi: [],
        telecomandoSelectedSelect: "",
    }

    navigateToDirect = () => {

    }

    render() {
        return (
            <body>
                
                <div className="App" style={{
                    backgroundImage: "url(Remotes.jpg)",
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}>
                    <center>
                        <div style={{ width: "60%" }}><h2 style={{ marginTop: "45vh", textAlign: "left" }}>Compatibilità HERMES.MF</h2></div>
                        <div className="div_search vertical_center" style={{ width: "60%" }}>
                            <div>
                                <div id="container_select_marca" style={{
                                    color: 'hsl(0, 0%, 40%)',
                                    display: 'inline-block',
                                    fontSize: 12,
                                    fontStyle: 'italic',
                                    width: "30%",
                                    float: "left"
                                }}>
                                    <Select
                                        defaultValue={this.state.marcaSelected}
                                        placeholder={"Marca"}
                                        onChange={(value) => {
                                            console.log(value["value"])
                                            this.setState({
                                                marcaSelected: value["value"],
                                                telecomandi: getModelliForDropdown(value["value"]),
                                                telecomandoSelectedSelect: null
                                            })
                                        }}
                                        options={this.state.marchi}
                                    />
                                </div>
                            </div>

                            <div id="container_select_model" style={{
                                color: 'hsl(0, 0%, 40%)',
                                display: 'inline-block',
                                fontSize: 12,
                                fontStyle: 'italic',
                                width: "30%",
                            }}>
                                <Select
                                    defaultValue={this.state.telecomandi[0]}
                                    placeholder={"Modello"}
                                    value={this.state.telecomandoSelectedSelect}
                                    onChange={(value) => {
                                        this.setState({
                                            telecomandoSelected: value["value"],
                                            telecomandoSelectedSelect: value
                                        })
                                    }}
                                    options={this.state.telecomandi}
                                />
                            </div>
                            <button class="button-3" onClick={
                                () => {
                                    console.log(this.state.telecomandoSelected)
                                    if (this.state.marcaSelected.includes("FAAC")) {
                                        if (this.state.telecomandoSelected.includes("diretto")) {
                                            window.open('https://www.domotime.com/senza-categoria/duplicazione-diretto-hermes-mf-faac/#body', '_blank').focus()
                                        } else if (this.state.telecomandoSelected.includes("autoapprendimento")) {
                                            window.open('https://www.domotime.com/senza-categoria/duplicazione-auto-apprendimento-hermes-mf/#body', '_blank').focus()
                                        } else if (this.state.telecomandoSelected.includes("ricevente")) {
                                            window.open('https://www.domotime.com/senza-categoria/duplicazione-in-ricevente-hermes-mf-faac/#body', '_blank').focus()
                                        }
                                        return;
                                    } else if (this.state.marcaSelected.includes("BFT")) {
                                        window.open('https://www.domotime.com/senza-categoria/duplicazione-in-autoapprendimento-hermes-mf-bft/#body', '_blank').focus()
                                        return;
                                    } else if (this.state.marcaSelected.includes("V2")) {
                                        window.open('https://www.domotime.com/senza-categoria/duplicazione-in-autoapprendimento-hermes-mf-v2/#body', '_blank').focus()
                                        return;
                                    }
                                    if (this.state.telecomandoSelected.includes("diretto")) {
                                        window.open('https://www.domotime.com/senza-categoria/duplicazione-diretta-hermes-mf/#body', '_blank').focus()
                                    } else if (this.state.telecomandoSelected.includes("autoapprendimento")) {
                                        window.open('https://www.domotime.com/senza-categoria/duplicazione-auto-apprendimento-hermes-mf/#body', '_blank').focus()
                                    } else if (this.state.telecomandoSelected.includes("ricevente")) {
                                        window.open('https://www.domotime.com/senza-categoria/duplicazione-in-ricevente-hermes-mf/#body', '_blank').focus()
                                    }
                                }
                            }>Cerca</button>

                        </div>
                    </center>
                </div >
            </body>

        )
    }
}

export default Home;